import { gql } from '@apollo/client';

export const GET_KPI_ROL = gql`
    query GetKpisRol($idRol: Int!) {
        kpisRol(idRol: $idRol) {
            success
            error
            valorEsperado {
                idKpi
                nombre
                descripcion
                link
                activo
            }
        }
    }
`;